export default __webpack_public_path__ + "static/media/gallery_01.c9c769a3.jpg";